module.exports = __webpack_public_path__ + "permalip_01_20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akce/permalip_01_20.jpg
// module id = 842
// module chunks = 0